import tippy from 'tippy.js'

// v-tooltip="'plain text'" renders escaped text (safe for dynamic data).
// v-tooltip="{ content: html, allowHTML: true }" opts into HTML rendering —
// reserve it for trusted, static markup.
function parseBinding(value) {
  if (value && typeof value === 'object') {
    return { content: value.content, allowHTML: value.allowHTML === true }
  }
  return { content: value, allowHTML: false }
}

export default {
  mounted(el, binding, vnode) {
    const { content, allowHTML } = parseBinding(binding.value)
    vnode.tippy = tippy(el, {
      theme: 'light',
      maxWidth: 400,
      content,
      trigger: 'mouseenter',
      allowHTML,
      onShow(instance) {
        // Don't show tooltip if content is empty, null, or undefined
        if (!instance.props.content) return false

        const tippyContent = instance.popper.querySelector('.tippy-content')
        if (tippyContent) {
          tippyContent.classList.add('wrap-anywhere')
        }
      }
    })
  },
  updated(_, binding, vnode, oldVnode) {
    vnode.tippy = oldVnode.tippy
    const { content, allowHTML } = parseBinding(binding.value)
    vnode.tippy.setProps({ content, allowHTML })
  },
  unmounted(_, __, vnode) {
    vnode.tippy.destroy()
  }
}
